module.exports = __webpack_public_path__ + "static/img/floorMenu.e97808a0.png";